module.exports = __webpack_public_path__ + "img/new_issues.a7a979e7.svg";